import './index.scss';
import { ChangeEvent, useEffect, useState } from 'react';
import { TextField as MaterialTextField, TextFieldProps } from '@material-ui/core';
import { InputClasses } from '@mui/material';

export interface ITextFieldProps {
  id?: string;
  type?: TextFieldProps['type'];
  variant?: TextFieldProps['variant'];
  value?: string;
  multiline?: boolean;
  minRows?: number | string;
  placeholder?: string;
  helperText?: string;
  error?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>, index?: number, key?: number) => void;
  // TODO: Define schema type
  schema?: any;
  index?: number;
  isGroup?: boolean;
  InputProps?: TextFieldProps;
  defaultValue?: string;
  name?: string;
  dataTestId?: string;
  classes?: Partial<InputClasses>;
}

export const TextField = ({
  id,
  type = 'text',
  value,
  variant = 'outlined',
  placeholder,
  multiline = false,
  minRows,
  error = false,
  disabled = false,
  onChange,
  schema,
  index,
  isGroup = false,
  fullWidth = false,
  InputProps,
  defaultValue,
  helperText,
  name,
  dataTestId: dataTestIdProp,
  classes,
}: ITextFieldProps) => {
  const [isDefault, setIsDefault] = useState(false);
  const handleChange = isGroup
    ? (event: ChangeEvent<HTMLInputElement>) => {
        onChange(event);
      }
    : (event: ChangeEvent<HTMLInputElement>) => {
        onChange(event, index, schema.key);
      };
  const { properties } = schema
    ? schema
    : {
        properties: { variant: variant, placeholder: placeholder, minRows: minRows },
      };
  useEffect(() => {
    setIsDefault(true);
  }, []);
  const dataTestId = dataTestIdProp ?? 'text-field' + (schema?.key ? `-${schema.key}` : '');
  return (
    <div className="text-field-container">
      <MaterialTextField
        data-testid={dataTestId}
        InputProps={InputProps}
        id={id}
        type={type}
        value={isDefault ? value : defaultValue}
        multiline={multiline}
        error={error}
        disabled={disabled}
        onChange={handleChange}
        index={index}
        helperText={helperText}
        fullWidth={fullWidth}
        name={name}
        classes={classes}
        {...properties}
      />
    </div>
  );
};
